export default __webpack_public_path__ + "static/illo-bank-bba4d00ef47f0e2e63a7d0a7ffcf139b.svg";